export default function PrivacyPolicy() {
  return (
    <main className="mt-12 md:mt-0" style={{ background: "#fafafa", minHeight: "100vh", fontFamily: "sans-serif" }}>

      {/* HERO */}
    {/* HERO */}
<div style={{
  background: "linear-gradient(to bottom, #6A1B9A, #9C27B0)",
  padding: "25px 24px 25px",
  textAlign: "center",
  
}}>
        
        <h1 style={{ color: "#fff", fontSize: "clamp(28px, 5vw, 48px)", fontWeight: "700", margin: "0 0 14px", fontFamily: "Georgia, serif" }}>
          Privacy Policy
        </h1>
        <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>
          Last updated: 27 April 2026
        </p>
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: "820px", margin: "0 auto", padding: "48px 24px 80px" }}>

        <Section title="Overview">
          <P>Your privacy is important to us. This Privacy Policy sets out the procedures and policies of <strong>Maheshwari Industries</strong> regarding the processing, collection, use, and disclosure of personal data we receive about you or from you through <a href="https://www.confidays.com" style={{ color: "#EC4899" }}>www.confidays.com</a>.</P>
          <P>By accessing or using the Site or App, you acknowledge that you have been informed of the manner in which your personal data may be collected, used, stored, and disclosed in accordance with this Privacy Policy. If you do not agree with the terms of this Privacy Policy, kindly do not access or use the Site or App.</P>
          <P>This Privacy Policy is incorporated into and subject to the terms of the Terms of Use.</P>
        </Section>

        <Section title="Categories of Personal Data Processed">
          <SubTitle>Usage and Device Information</SubTitle>
          <P>When you access or use the Site or App, we may collect certain information relating to your device and usage, such as your IP address, device type, operating system, browser or application version, location, date and time of access, pages you visit, and information relating to your interactions with the Site or App.</P>

          <SubTitle>Account and Contact Information</SubTitle>
          <P>If you choose to create an account, place an order, fill out the contact form, or otherwise interact with the Site or App, we may collect personal data including your name, email address, phone number, delivery address, and other contact details.</P>

          <SubTitle>Transaction Information</SubTitle>
          <P>Where you purchase products through the Site or App, we may collect information relating to such transactions, including order details, delivery information, and limited payment confirmation information. Payment information is processed through authorised payment service providers and we do not store complete debit or credit card details on our systems.</P>

          <SubTitle>Health, Wellness and Menstrual Information</SubTitle>
          <P>Where you choose to use features of the App relating to menstrual health, wellness, or product suitability, we may collect information voluntarily provided by you relating to your age, menstrual cycle, flow patterns, symptoms, wellness indicators, and other health or lifestyle information.</P>

          <SubTitle>Communications and Interactive Features</SubTitle>
          <P>We may collect and retain information contained in communications sent by you to us through the Site, App, email, or other communication channels.</P>
        </Section>

        <Section title="Use and Sharing of Information">
          <P>Any information we receive about you or from you may be used by us or shared with our affiliates and other third parties to help process your request; to comply with any law; to help improve our Site or App or the products or services we offer; for research; to better understand our customers' needs; to develop new offerings; and to alert you to new products and services.</P>
          <P>We do not share, sell, trade or rent your personal information to third parties for unknown reasons.</P>
        </Section>

        <Section title="Personal Data of Children and Persons with Disabilities">
          <P>Persons under the age of 18 years are not eligible to use the Site or App or register as a user. If you are a minor i.e. under the age of 18 years but at least 13 years of age, you may use the Site or App only under the supervision of a parent or legal guardian.</P>
          <P>If we become aware that we have inadvertently received personal information from a visitor under the age of eighteen (18), we will delete the information from our records.</P>
        </Section>

        <Section title="Your Rights and Grievance Redressal">
          <P>You may exercise your rights in relation to your personal data in accordance with applicable law, including the right to seek access, correction, updating, erasure, or withdraw consent.</P>
          <P>To exercise any such rights or to submit a grievance, you may contact our Grievance Officer using the contact details provided below. We will endeavour to acknowledge and address your request or grievance within <strong>90 days</strong> from the date of receipt.</P>
          <P>If your grievance is not addressed satisfactorily, you may escalate the matter to the <strong>Data Protection Board of India</strong>.</P>
        </Section>

        <Section title="Deletion of Data">
          <P>You can submit a data deletion request through our Service Center at <a href="mailto:care@confidays.com" style={{ color: "#EC4899" }}>care@confidays.com</a>. Please include as much information as possible regarding which data you would like to be deleted.</P>
          <P>If you terminate your account, any association between your account and the information we store will no longer be accessible through your account. However, any public activity on your account prior to deletion will remain stored on our servers.</P>
        </Section>

        <Section title="Retention of Personal Data">
          <P>We shall retain personal data only for such period as is necessary to fulfil the purposes set out in this Privacy Policy, and in accordance with applicable law. Where retention is no longer required, the personal data shall be securely deleted, anonymised, or otherwise rendered non-identifiable.</P>
        </Section>

        <Section title="Data Breach Reporting">
          <P>Any suspected breach of data, personal or non-personal, should be reported within <strong>72 hours</strong> by writing to <a href="mailto:care@confidays.com" style={{ color: "#EC4899" }}>care@confidays.com</a>.</P>
        </Section>

        <Section title="Cookies">
          <P>"Cookies" are small identifiers sent from a web server and stored on your computer's hard drive, that help us recognize you if you visit our Site again. Our Site uses cookies to track how you found our site. To protect your privacy, we do not use cookies to store or transmit any personal information about you on the Internet.</P>
          <P>You have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer.</P>
        </Section>

        <Section title="Security">
          <P>We implement reasonable technical, administrative, and organisational security measures designed to protect personal data against unauthorised access, disclosure, alteration, or destruction. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</P>
        </Section>

        <Section title="Governing Law and Jurisdiction">
          <P>These conditions are governed by and construed in accordance with the laws of India. You agree to submit to the exclusive jurisdiction of the courts at <strong>Mumbai</strong>.</P>
        </Section>

        <Section title="Changes to this Privacy Policy">
          <P>We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or operational needs. Your continued use of the Site or App after the updated Privacy Policy is made available constitutes your acknowledgement of the updated notice.</P>
        </Section>

        {/* GRIEVANCE OFFICER CARD */}
        <div style={{
          background: "linear-gradient(135deg, #f0f3ff, #fff0f7)",
          border: "1px solid #e0e7ff",
          borderRadius: "16px",
          padding: "28px 32px",
          marginTop: "8px",
        }}>
          <p style={{ fontSize: "13px", color: "#EC4899", fontWeight: "700", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "14px" }}>
            Grievance Officer
          </p>
          <p style={{ fontSize: "16px", fontWeight: "700", color: "#1A237E", marginBottom: "6px" }}>
            Mridula Mukundan
          </p>
          <p style={{ fontSize: "14px", color: "#555", marginBottom: "4px" }}>
            Maheshwari Industries
          </p>
          <a href="mailto:care@confidays.com" style={{
            display: "inline-block",
            marginTop: "10px",
            fontSize: "14px",
            color: "#EC4899",
            fontWeight: "600",
            textDecoration: "none",
          }}>
            care@confidays.com
          </a>
        </div>

      </div>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "40px", borderBottom: "1px solid #f0f0f0", paddingBottom: "36px" }}>
      <h2 style={{
        fontSize: "20px",
        fontWeight: "700",
        color: "#1A237E",
        marginBottom: "16px",
        paddingLeft: "14px",
        borderLeft: "3px solid #EC4899",
        fontFamily: "Georgia, serif",
      }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

function SubTitle({ children }) {
  return (
    <p style={{
      fontSize: "13px",
      fontWeight: "700",
      color: "#EC4899",
      textTransform: "uppercase",
      letterSpacing: "1px",
      marginTop: "20px",
      marginBottom: "8px",
    }}>
      {children}
    </p>
  );
}

function P({ children }) {
  return (
    <p style={{
      fontSize: "15px",
      lineHeight: "1.85",
      color: "#444",
      marginBottom: "12px",
    }}>
      {children}
    </p>
  );
}